"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DslRuntimeModuleSymbol = Symbol.for('DslRuntimeModule');
function moduleImplementation(name, implementation, ...parameters) {
    return { name, implementation, parameters };
}
exports.moduleImplementation = moduleImplementation;
//# sourceMappingURL=runtime-module.js.map